/* eslint-disable react/no-unused-state,
    react/destructuring-assignment */

import React, { Component } from "react";
import PropTypes from "prop-types";

import CommentsService from "services/CommentsService";
import InputField from "./InputField";
import Textarea from "./Textarea";
import EmoticonField from "./EmoticonField";

import "../comments-forms.scss";

class CommentsForm extends Component {
  constructor(props) {
    super();

    this.fields = [
      {
        type: "textarea",
        name: "comment",
        label: "Jouw reactie",
      },
      {
        type: "text",
        name: "name",
        label: "Voornaam",
      },
      {
        type: "text",
        name: "surname",
        label: "Naam",
        description: "Wordt niet publiek getoond",
      },
      {
        type: "email",
        name: "email",
        label: "E-mailadres",
        description: "Wordt niet publiek getoond",
      },
      {
        type: "text",
        name: "city",
        label: "Gemeente",
      },
    ];

    this.state = {
      uuid: props.uuid,
      name: "",
      surname: "",
      email: "",
      city: "",
      comment: "",
      emoticon: 1,
      submitting: false,
      submitted: false,
      error: false,
    };
  }

  onInputChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  };

  handleOnSubmit = async (e) => {
    e.preventDefault();

    this.setState({
      submitting: true,
    });

    const { uuid, name, surname, email, city, comment, emoticon } = this.state;

    try {
      await CommentsService.sendComment({
        uuid,
        name,
        surname,
        email,
        city,
        comment,
        emoticon,
      });

      this.setState({
        submitting: false,
        submitted: true,
      });

      this.resetFields();
      this.props.onScrollTop();
    } catch (error) {
      this.setState({
        error: true,
        submitting: false,
        submitted: false,
      });
    }
  };

  renderFormItems = () => this.fields.map((item) => this.renderFormItem(item));

  renderFormItem = (item) => {
    switch (item.type) {
      case "textarea":
        return (
          <Textarea
            key={item.name}
            onInputChange={this.onInputChange}
            value={this.state[item.name]}
            {...item}
          />
        );
      default:
        return (
          <InputField
            key={item.name}
            onInputChange={this.onInputChange}
            value={this.state[item.name]}
            {...item}
          />
        );
    }
  };

  renderSubmitted = () => (
    <div className="ket-comments__form comments-form">
      Bedankt voor je reactie. De webmaster bekijkt die vooraf eerst nog even.
      Zodra je reactie gepubliceerd is, kan je ze hier lezen.
    </div>
  );

  resetFields = () => {
    this.setState({
      name: "",
      surname: "",
      email: "",
      city: "",
      comment: "",
    });
  };

  renderForm = () => {
    const { emoticon, submitting } = this.state;
    const { rules } = this.props;

    return (
      <div className="ket-comments">
        <header className="ket-comments__header">
          <h2 className="section-heading__title">
            Laat hier jouw reactie achter:
          </h2>
          {rules && (
            <a
              className="ket-comments__rules"
              href={rules}
              target="_blank"
              rel="noopener noreferrer"
            >
              Een paar afspraken rond reageren
            </a>
          )}
        </header>
        <form
          className="ket-comments__form comments-form"
          onSubmit={this.handleOnSubmit}
        >
          <EmoticonField onInputChange={this.onInputChange} value={emoticon} />
          {this.renderFormItems()}
          <div className="form-item">
            <button
              className="btn is-default"
              disabled={submitting}
              type="submit"
            >
              Versturen
            </button>
          </div>
        </form>
      </div>
    );
  };

  render() {
    const { error, submitted } = this.state;
    const { open } = this.props;

    if (!open) return null;

    return (
      <>
        {submitted && <>{this.renderSubmitted()}</>}
        {this.renderForm()}
        {error && (
          <div className="message message--error">
            Er ging iets mis bij het versturen van je reactie. Probeer het nog
            een keer.
          </div>
        )}
      </>
    );
  }
}

CommentsForm.propTypes = {
  uuid: PropTypes.string.isRequired,
  rules: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onScrollTop: PropTypes.func.isRequired,
};

CommentsForm.defaultProps = {
  rules: null,
};

export default CommentsForm;
